import { render } from "./dol-drawer.vue?vue&type=template&id=4fa3190d"
import script from "./dol-drawer.vue?vue&type=script&lang=js"
export * from "./dol-drawer.vue?vue&type=script&lang=js"

import "./dol-drawer.vue?vue&type=style&index=0&id=4fa3190d&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__